import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../Styles/PortalPolicies.scss";
import { Tooltip } from "antd";
import { ShieldCheck, X, Sparkles, Mail, MapPin } from "lucide-react";

const TermsAndConditionsModal = ({ showModal, handleAgree }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleAgreeClick = () => {
    if (isChecked) {
      handleAgree();
    }
  };

  return (
    <AnimatePresence>
      {showModal && (
        <>
          {/* Apple Spatial Backdrop Blur */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="apple-spatial-backdrop"
            onClick={handleAgree}
          />

          {/* Apple Spatial Glass Modal Window */}
          <motion.div
            initial={{ scale: 0.94, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.94, opacity: 0, y: 20 }}
            transition={{ type: "spring", damping: 28, stiffness: 280 }}
            className="apple-spatial-modal-window"
          >
            {/* Top Spatial Ambient Light Strip */}
            <div className="spatial-light-rim" />

            {/* Header Section */}
            <div className="apple-spatial-header">
              <div className="header-badge-row">
                <div className="apple-spatial-pill-badge">
                  <Sparkles size={13} />
                  <span>iNextLabs Official Policy</span>
                </div>
              </div>

              <div className="header-title-row">
                <div>
                  <h2 className="apple-spatial-title">iNextLabs Portal Usage Policies</h2>
                  <p className="apple-spatial-subtitle">
                    iNextLabs Pte. Ltd. • Singapore Registered
                  </p>
                </div>
                <button
                  type="button"
                  className="apple-spatial-close-icon"
                  onClick={handleAgree}
                  aria-label="Close modal"
                >
                  <X size={18} />
                </button>
              </div>
            </div>

            {/* Main Scrollable Canvas */}
            <div className="apple-spatial-scroll-canvas" data-lenis-prevent="true">
              {/* Card 1: Portal Usage & Guidelines */}
              <div className="apple-spatial-card intro-card">
                <div className="card-header">
                  <ShieldCheck size={22} className="card-header-icon" />
                  <div>
                    <h3 className="card-title">Dedicated Partner Platform & Usage Guidelines</h3>
                    <p className="card-subtitle" style={{ marginTop: "8px", fontSize: "14px", lineHeight: "1.65", color: "#333" }}>
                      The <strong>iNextLabs Partner Portal</strong> is a dedicated platform exclusively for partners of iNextLabs, designed to support their engagements and showcase iNextLabs’ solutions. Partners must adhere to strict guidelines regarding access and usage of the portal; sharing credentials or providing access outside of their organization without explicit permission from iNextLabs is strictly prohibited and considered a serious offense. The portal includes demos intended for presenting iNextLabs solutions to potential customers, and partners are encouraged to use these demos judiciously, as they incur usage charges that are tracked by partner. To help manage costs, video demonstrations are provided as an alternative to live demos.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 2: Demo Support & Reliability */}
              <div className="apple-spatial-card" style={{ padding: "20px", background: "#ffffff", borderRadius: "16px", border: "1px solid rgba(0,0,0,0.06)" }}>
                <h4 style={{ margin: "0 0 8px", fontSize: "15px", fontWeight: "700", color: "#1d1d1f" }}>
                  Prompt Support & Demo Assistance
                </h4>
                <p style={{ margin: 0, fontSize: "13.5px", lineHeight: "1.65", color: "#444" }}>
                  Should partners encounter any issues with the demos, iNextLabs offers prompt support to ensure any problems are quickly resolved. Partners are encouraged to reach out to the support team if they find any demo not functioning correctly, and iNextLabs will address the issue immediately. This ensures that partners can reliably showcase the full capabilities of iNextLabs' solutions to their prospective clients without disruption.
                </p>
              </div>

              {/* Contact Footer Card */}
              <div className="apple-spatial-card contact-footer-card">
                <div className="contact-grid">
                  <div className="contact-item">
                    <MapPin size={16} className="contact-icon" />
                    <span><strong>iNextLabs Pte. Ltd.</strong> — 1 Coleman Street, #10-06, The Adelphi, Singapore 179803</span>
                  </div>
                  <div className="contact-item">
                    <Mail size={16} className="contact-icon" />
                    <span>Support Email: <a href="mailto:info@inextlabs.com">info@inextlabs.com</a></span>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Ceramic Action Bar */}
            <div className="apple-spatial-action-bar">
              <div className="action-bar-left">
                <label htmlFor="termsCheckbox" className="spatial-checkbox-container">
                  <input
                    type="checkbox"
                    id="termsCheckbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    className="spatial-checkbox"
                  />
                  <span className="checkbox-custom" />
                  <span className="checkbox-text">
                    I understand and agree to the <strong>terms and conditions</strong>
                  </span>
                </label>
              </div>

              <div className="action-bar-right">
                <Tooltip title={!isChecked ? "Please check the box to agree" : ""}>
                  <button
                    type="button"
                    onClick={handleAgreeClick}
                    disabled={!isChecked}
                    className="apple-spatial-cta-btn"
                  >
                    <span>Agree</span>
                  </button>
                </Tooltip>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default TermsAndConditionsModal;
